import type { SidebarSectionBadgeComponent } from "@productlane/api/src/browser"
import type { BadgeProps } from "@productlane/ui"
import { Badge } from "@productlane/ui"

interface Props {
	component: SidebarSectionBadgeComponent
}

// Badges stay flat fills so they never read as an outline button.
const ColorMapping: Record<
	SidebarSectionBadgeComponent["color"],
	BadgeProps["variant"]
> = {
	gray: "dark-gray",
	green: "green",
	red: "red",
}

export function BadgeComponent({ component }: Props) {
	return (
		<Badge
			variant={ColorMapping[component.color]}
			size="sm"
			className="max-w-full truncate text-[11px]"
		>
			{component.text}
		</Badge>
	)
}
